var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-overlay',{staticClass:"mask_Box",attrs:{"absolute":true,"opacity":0.6,"value":_vm.props.isShow || false}},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"primary","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }